import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  Card,
  Container,
  Content,
  FiltersRow,
  Header,
  PageSubtitle,
  PageTitle,
  StatsRow,
} from './styles';
import { Painel } from '../../../../components/Painel';
import { Pagination } from '../../../../components/Pagination';
import { SearchField } from '../../../../components/SearchField';
import { GymsService, IGym } from '../../../../services/GymsService';
import { StatCard } from '../../../../components/StatCard';
import { TextInfo } from '../../../../components/TextInfo';

const PAGE_SIZE = 10;

const Gyms: React.FC = () => {
  const gymsService = new GymsService();

  const navigate = useNavigate();

  const [gyms, setGyms] = useState<IGym[]>([]);
  const [stats, setStats] = useState({ total: 0, active: 0 });
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [page, setPage] = useState(1);
  const [searchText, setSearchText] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedSearch(searchText), 400);

    return () => clearTimeout(timer);
  }, [searchText]);

  useEffect(() => {
    setPage(1);
  }, [debouncedSearch]);

  useEffect(() => {
    setLoading(true);
    gymsService
      .getGyms({ page, limit: PAGE_SIZE, search: debouncedSearch })
      .then(response => {
        setGyms(response.data.data);
        setTotal(response.data.total);
        setTotalPages(response.data.totalPages);
        setStats(response.data.stats);
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, debouncedSearch]);

  return (
    <Painel loading={loading}>
      <Container>
        <Header>
          <div>
            <PageTitle>Academias</PageTitle>
            <PageSubtitle>Gerenciamento global de academias</PageSubtitle>
          </div>
          <TextInfo text="BETA" />
        </Header>

        <StatsRow>
          <StatCard title="Total de academias" data={stats.total} />
          <StatCard title="Academias ativas" data={stats.active} />
        </StatsRow>

        <FiltersRow>
          <SearchField
            placeholder="Buscar academia"
            value={searchText}
            onChange={setSearchText}
          />
        </FiltersRow>

        <Content>
          {gyms.map(gym => (
            <Card
              key={gym.id}
              id={gym.id}
              name={gym.name}
              domain={gym.domain}
              is_active={gym.is_active}
              logo={gym.logo_url}
              onManage={() => navigate(`/admin/gyms/${gym.id}`)}
            />
          ))}
        </Content>

        <Pagination
          page={page}
          totalPages={totalPages}
          total={total}
          pageSize={PAGE_SIZE}
          itemLabel="academias"
          onPageChange={setPage}
        />
      </Container>
    </Painel>
  );
};

export { Gyms };
